class GaClipboard {
    constructor() {

    }
    initByID(targetID, containerID = null){
        // Select targets
        const target = document.getElementById(targetID);
        if(target){
            const button = target.nextElementSibling;

            let clipboard;
            if(containerID === null){
                clipboard = new ClipboardJS(button, {
                    target: target,
                    text: function () {
                        return target.innerHTML;
                    }
                });
            } else {
                clipboard = new ClipboardJS(button, {
                    container: document.getElementById(containerID),
                    target: target,
                    text: function () {
                        return target.innerHTML;
                    }
                });
            }

            // Success action handler
            clipboard.on('success', function (e) {
                let checkIcon = button.querySelector('.bi.bi-check');
                const svgIcon = button.querySelector('.svg-icon');

                // Exit check icon when already showing
                if (checkIcon) {
                    return;
                }

                // Create check icon
                checkIcon = document.createElement('i');
                checkIcon.classList.add('bi');
                checkIcon.classList.add('bi-check');
                checkIcon.classList.add('fs-2x');
                checkIcon.classList.add('text-white');

                // Append check icon
                button.appendChild(checkIcon);

                // Highlight target
                const classes = ['fw-boldest'];
                target.classList.add(...classes);

                // Highlight button
                button.classList.add('btn-success');

                // Hide copy icon
                svgIcon.classList.add('d-none');

                // Revert button label after 3 seconds
                setTimeout(function () {
                    // Remove check icon
                    svgIcon.classList.remove('d-none');

                    // Revert icon
                    button.removeChild(checkIcon);

                    // Remove target highlight
                    target.classList.remove(...classes);

                    // Remove button highlight
                    button.classList.remove('btn-success');
                }, 3000)
            });
        }
    }
    initByClass(targetClass, containerID = null){
        // Select targets
        const targets = document.getElementsByClassName(targetClass);
        if(targets){
            for (const target of targets) {
                const button = target.nextElementSibling;

                let clipboard;
                if(containerID === null){
                    clipboard = new ClipboardJS(button, {
                        target: target,
                        text: function () {
                            return target.innerHTML;
                        }
                    });
                } else {
                    clipboard = new ClipboardJS(button, {
                        container: document.getElementById(containerID),
                        target: target,
                        text: function () {
                            return 'test';
                        }
                    });
                }

                // Success action handler
                clipboard.on('success', function (e) {
                    let checkIcon = button.querySelector('.bi.bi-check');
                    const svgIcon = button.querySelector('.svg-icon');

                    // Exit check icon when already showing
                    if (checkIcon) {
                        return;
                    }

                    // Create check icon
                    checkIcon = document.createElement('i');
                    checkIcon.classList.add('bi');
                    checkIcon.classList.add('bi-check');
                    checkIcon.classList.add('fs-2x');
                    checkIcon.classList.add('text-white');

                    // Append check icon
                    button.appendChild(checkIcon);

                    // Highlight target
                    const classes = ['fw-boldest'];
                    target.classList.add(...classes);

                    // Highlight button
                    button.classList.add('btn-success');

                    // Hide copy icon
                    svgIcon.classList.add('d-none');

                    // Revert button label after 3 seconds
                    setTimeout(function () {
                        // Remove check icon
                        svgIcon.classList.remove('d-none');

                        // Revert icon
                        button.removeChild(checkIcon);

                        // Remove target highlight
                        target.classList.remove(...classes);

                        // Remove button highlight
                        button.classList.remove('btn-success');
                    }, 3000)
                });
            }
        }
    }
}
window.GaClipboard = GaClipboard;